import { app, Component } from "modular-openscriptjs";

const h = app("h");

export default class EditProductImageForm extends Component {
	render(src, ...args) {
		return h.$(
			h.div(
				h.img({
					id: "epif-image-view",
					class: "d-none w-100",
					src,
				}),
				...args
			)
		);
	}
}
